import React, {Component} from 'react';
import {IonBackButton, IonButtons, IonHeader, IonMenuButton, IonSearchbar, IonToolbar} from '@ionic/react';
import "../ContestDetailPage.css"
import {History} from 'history';
import {SearchbarChangeEventDetail} from '@ionic/core';

type Props = SearchProps & {
  onBack: () => void;
  canGoBack: boolean;
};

type State = {}

export type SearchProps = {
  searchBarEnabled: boolean;
  onSearchChanged?: (value: string | undefined) => void;
  searchValue?: string;
}

export default class ContestDetailTabHeader extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            {this.renderBackButton()}
            {this.renderMenuButton()}
          </IonButtons>
          {this.renderSearchBar()}
        </IonToolbar>
        {this.props.children}
      </IonHeader>
    );
  }

  private renderMenuButton() {
    if (!this.props.canGoBack) {
      return (
        <IonMenuButton/>
      );
    }
  }

  private renderBackButton() {
    if (this.props.canGoBack) {
      return (
        <IonBackButton
          onClick={() => {
            this.props.onBack();
          }}
          defaultHref={'#'}
          goBack={() => console.log("go back is not supported like this (use on click handler)")}/>
      );
    }
  }

  private renderSearchBar() {
    if (!this.props.searchBarEnabled) {
      return null;
    }
    return (
      <IonSearchbar
        onIonChange={
          (event: CustomEvent<SearchbarChangeEventDetail>) =>
            this.props.onSearchChanged
              ? this.props.onSearchChanged(event.detail.value)
              : () => {
              }
        }
        value={this.props.searchValue}
      >&nbsp;</IonSearchbar>
    );
  }
}
